import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { USE_UTC } from '@constants/http-context-token';
import { map } from 'rxjs/operators';

export const UtcInterceptor: HttpInterceptorFn = (req, next) => {
  const shouldUseUTC = req.context.get(USE_UTC);

  return next(req).pipe(
    map(event => {
      if (event instanceof HttpResponse && shouldUseUTC) {
        return event.clone({ body: replaceUtcFields(event.body) });
      }
      return event;
    })
  );
};

function replaceUtcFields(body: any): any {
  if (!body || typeof body !== 'object') {return body;}

  if (Array.isArray(body)) {
    return body.map(item => replaceUtcFields(item));
  }

  const newObj: any = {};
  for (const key of Object.keys(body)) {
    if (body[`${key}_utc`] !== undefined) {
      newObj[key] = body[`${key}_utc`];
    } else {
      newObj[key] = replaceUtcFields(body[key]);
    }
  }
  return newObj;
}
